<div class="flex flex-column h-full surface-card overflow-hidden">
    <!-- Header -->
    <div class="flex-none px-4 py-3 surface-50 border-bottom-1 surface-border flex align-items-center justify-content-between">
        <div class="flex align-items-center gap-3">
            <p-button icon="pi pi-arrow-left" [rounded]="true" [text]="true" severity="secondary"
                (onClick)="cancel()" pTooltip="Volver al formulario" [style]="{ 'width': '36px', 'height': '36px' }"></p-button>
            <div>
                <div class="font-bold text-900 text-lg line-height-2">{{ title }}</div>
                <div class="text-500 text-xs mt-1">{{ subtitle }}</div>
            </div>
        </div>
        <p-button *ngIf="showCancelButton" [label]="backButtonLabel" icon="pi pi-arrow-left" severity="secondary" [outlined]="true"
            (onClick)="cancel()" size="small"></p-button>
    </div>

    <!-- Filters & Search Toolbar -->
    <div class="flex-none px-4 py-3 border-bottom-1 surface-border flex flex-wrap align-items-center justify-content-between gap-3 bg-white">
        <!-- Search input -->
        <div class="relative flex-grow-1" style="max-width: 440px;">
            <i class="pi pi-search absolute text-500" style="left: 14px; top: 50%; transform: translateY(-50%); z-index: 2; pointer-events: none; font-size: 14px;"></i>
            <input pInputText type="text" [(ngModel)]="searchQuery" (ngModelChange)="onSearchInput($event)"
                placeholder="Buscar por código, nombre o abreviatura..." 
                class="w-full text-sm surface-50 border-1 border-300 border-round-lg hover:border-primary transition-colors"
                style="padding-left: 38px !important; padding-right: 32px !important; height: 38px;" />
            <button *ngIf="searchQuery" type="button" (click)="clearSearch()"
                class="p-link absolute text-400 hover:text-700 flex align-items-center justify-content-center cursor-pointer border-none bg-transparent"
                style="right: 8px; top: 50%; transform: translateY(-50%); width: 24px; height: 24px; z-index: 2;"
                pTooltip="Limpiar búsqueda">
                <i class="pi pi-times text-xs"></i>
            </button>
        </div>

        <!-- Quick Filters -->
        <div class="flex align-items-center gap-3">
            <div class="flex align-items-center gap-2">
                <label for="filterActive" class="text-xs font-medium text-600">Mostrar:</label>
                <p-select id="filterActive" [options]="statusOptions" [(ngModel)]="statusFilter"
                    (onChange)="onStatusFilterChange()" optionLabel="label" optionValue="value"
                    [style]="{ 'font-size': '12.5px', 'min-width': '170px' }">
                </p-select>
            </div>

            <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" severity="secondary"
                (onClick)="loadAnalites()" pTooltip="Actualizar lista"></p-button>

            <span class="text-xs text-blue-700 bg-blue-50 px-2 py-1 border-round font-medium">
                {{ totalRecords }} determinaciones
            </span>
        </div>
    </div>

    <!-- Table Container -->
    <div class="flex-grow-1 overflow-hidden p-3" style="min-height: 0;">
        <p-table [value]="analites" [lazy]="true" (onLazyLoad)="onLazyLoad($event)"
            [paginator]="true" [rows]="pageSize" [totalRecords]="totalRecords" [first]="first"
            [loading]="loading" selectionMode="single" [(selection)]="selectedAnalite"
            (onRowDblClick)="selectItem(selectedAnalite)"
            [rowsPerPageOptions]="[10, 20, 50]"
            [paginatorDropdownAppendTo]="'body'"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} determinaciones"
            styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines select-analite-table"
            [scrollable]="true" scrollHeight="flex">

            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 110px;" pSortableColumn="code">
                        Código <p-sortIcon field="code"></p-sortIcon>
                    </th>
                    <th pSortableColumn="name">
                        Nombre <p-sortIcon field="name"></p-sortIcon>
                    </th>
                    <th style="width: 140px;" pSortableColumn="abbreviation">
                        Abreviatura <p-sortIcon field="abbreviation"></p-sortIcon>
                    </th>
                    <th style="width: 220px;">Grupos de Sustancias</th>
                    <th style="width: 110px; text-align: center;" pSortableColumn="active">
                        Estado <p-sortIcon field="active"></p-sortIcon>
                    </th>
                    <th style="width: 130px; text-align: center;">Acción</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-analite>
                <tr [pSelectableRow]="analite" [class.opacity-60]="!analite.active" style="cursor: pointer;">
                    <td>
                        <span class="font-mono font-semibold text-xs px-2 py-1 surface-100 border-round text-700">
                            {{ analite.formattedCode || formatCode(analite.code) }}
                        </span>
                    </td>
                    <td>
                        <span class="font-semibold text-900 text-sm">{{ analite.name }}</span>
                    </td>
                    <td>
                        <span *ngIf="analite.abbreviation" class="text-xs text-700 surface-200 px-2 py-1 border-round font-medium">
                            {{ analite.abbreviation }}
                        </span>
                        <span *ngIf="!analite.abbreviation" class="text-400 text-xs italic">-</span>
                    </td>
                    <td>
                        <div *ngIf="analite.substancesGroups?.length" class="flex flex-wrap gap-1">
                            <span *ngFor="let group of analite.substancesGroups" class="text-xs bg-indigo-50 text-indigo-700 px-2 py-0 border-round">
                                {{ group }}
                            </span>
                        </div>
                        <span *ngIf="!analite.substancesGroups?.length" class="text-400 text-xs italic">-</span>
                    </td>
                    <td class="text-center">
                        <p-tag [value]="analite.active ? 'Activo' : 'Inactivo'"
                               [severity]="analite.active ? 'success' : 'danger'"
                               [rounded]="true" styleClass="text-xs font-medium"></p-tag>
                    </td>
                    <td class="text-center">
                        <p-button label="Seleccionar" icon="pi pi-check" size="small" [rounded]="true"
                            severity="primary" [disabled]="!analite.active" (onClick)="selectItem(analite)"
                            [pTooltip]="analite.active ? 'Seleccionar esta determinación' : 'Determinación inactiva'">
                        </p-button>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6" class="text-center py-5">
                        <div class="flex flex-column align-items-center justify-content-center text-500 gap-2">
                            <i class="pi pi-search text-3xl text-300"></i>
                            <div class="font-medium">No se encontraron determinaciones</div>
                            <div class="text-xs text-400">Intente modificar los términos de búsqueda o el filtro de estado</div>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- Bottom Selected / Confirmation Bar -->
    <div class="flex-none px-4 py-3 surface-50 border-top-1 surface-border flex align-items-center justify-content-between gap-3">
        <div class="flex align-items-center gap-2">
            <ng-container *ngIf="selectedAnalite; else noSelected">
                <i class="pi pi-check-circle text-primary text-base"></i>
                <span class="text-xs text-600">Determinación seleccionada:</span>
                <strong class="text-sm text-900">{{ selectedAnalite.name }}</strong>
                <span class="text-xs text-500 font-mono">({{ selectedAnalite.formattedCode || formatCode(selectedAnalite.code) }})</span>
            </ng-container>
            <ng-template #noSelected>
                <i class="pi pi-info-circle text-400 text-sm"></i>
                <span class="text-xs text-500">Haga clic en una fila para seleccionarla o doble clic para aplicar de inmediato</span>
            </ng-template>
        </div>

        <div class="flex align-items-center gap-2">
            <p-button *ngIf="showCancelButton" label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true"
                (onClick)="cancel()" size="small"></p-button>
            <p-button label="Confirmar Selección" icon="pi pi-check" severity="primary"
                [disabled]="!selectedAnalite || !selectedAnalite.active"
                (onClick)="selectItem(selectedAnalite)" size="small"></p-button>
        </div>
    </div>
</div>
